import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { ImportBudgetService } from './api-servicese/import-budget.service';
import { ImportBusinessCalenderService } from './api-servicese/import-business-calender.service';
import { ImportDistributionRatioService } from './api-servicese/import-distribution-ratio.service';
import { ImportUseNumPeopleService } from './api-servicese/import-use-num-people.service';
import { KYMW9400Component } from './kymw9400.component';

/**
 * 外部システム連携画面 モジュール設定クラス
 *
 * @export KYMW9400Module
 * @class KYMW9400Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
  ],
  declarations: [
    KYMW9400Component,
  ],
  providers: [
    ImportBudgetService,
    ImportBusinessCalenderService,
    ImportDistributionRatioService,
    ImportUseNumPeopleService,
  ],
})
export class KYMW9400Module {

}
